import React from "react";

// Default / System Built-in badges shown for a template. Shared by the list
// row, the mobile card, and the editor header so the markup stays in one place.
const ContractBadges = ({ template }) => {
  if (!template?.is_default && !template?.is_system) return null;
  return (
    <div className="contract-badges">
      {template.is_default && (
        <span className="contract-badge contract-badge-default">Default</span>
      )}
      {template.is_system && (
        <span className="contract-badge contract-badge-builtin">
          System Built-in
        </span>
      )}
    </div>
  );
};

export default ContractBadges;
